import { CatButton } from '@blocks-react/components/Button';
import { CatIconExternalLinkBox } from '@blocks-react/components/Icons/ExternalLinkBox';
import { VisionLinkExternalLinkButtonProp } from '../../types';
import styles from '../../VisionLink.module.scss';

export const VisionLinkExternalLinkButton = ({
  href,
  buttonLabel,
  className
}: Readonly<VisionLinkExternalLinkButtonProp>) => {
  return (
    <CatButton
      variant="ghost"
      size="sm"
      href={href}
      target="_blank"
      className={className}
    >
      <span className={`${styles['vision-link-button']} pe-2`}>
        {buttonLabel}
      </span>
      <CatIconExternalLinkBox size="sm" slot="after" />
    </CatButton>
  );
};
